import { AssetDTO } from 'config/api/assets/assets.types';

const assetOptionsParser = ({ results }: { results: AssetDTO[] }) =>
  results.map(({ id, name, category, owner }) => {
    const ownerName = owner?.profile ? `${owner.profile.first_name} ${owner.profile.last_name}`.trim() || owner.email : owner?.email || '';
    const categoryWithLegacyKey = category as typeof category & { nameTranslationKey?: string };
    const categoryTranslationKey = categoryWithLegacyKey?.name_translation_key || categoryWithLegacyKey?.nameTranslationKey || null;

    return {
      key: id,
      id,
      name,
      category: [categoryTranslationKey, category?.name || ''],
      owner: ownerName,
    };
  });
export default assetOptionsParser;
